import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LiveOrdersData } from '../../models/LiveOrders';

const initialState: LiveOrderDetailsState = {
    open: false,
    dialogContent: null,
};

export const liveOrderDetailsDialogSlice = createSlice({
    name: 'liveOrderDetailsDialog',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setDetailsDialog: (state, action: PayloadAction<LiveOrdersData>) => {
            state.dialogContent = action.payload;
        },
    },
});

export interface LiveOrderDetailsState {
    open: boolean;
    dialogContent: LiveOrdersData | null | undefined;
}

export const liveOrderDetailsDialogAction = liveOrderDetailsDialogSlice.actions;

export default liveOrderDetailsDialogSlice.reducer;
